export default "__VITE_PUBLIC_ASSET__527fc5eb__"